import jwtDecode from 'jwt-decode';
import * as types from '../types';
import authApi from '../../apis/auth';
import adminApi from '../../apis/admin';

export const onLogout = () => (dispatch) => {
  localStorage.removeItem('token');
  dispatch({ type: types.SIGN_OUT });
};

export const onLogin = ({ username, password, remember }) => async (dispatch) => {
  try {
    dispatch({
      type: types.SIGN_LOADING,
    });
    const {
      data: { token },
    } = await authApi.post('auth/login', { username, password });
    if (remember) {
      localStorage.setItem('token', token);
    }
    adminApi.defaults.headers.common = { Authorization: `Bearer ${token}` };
    const user = jwtDecode(token);
    dispatch({
      type: types.SIGN_IN_SUCCESS,
      payload: {
        user,
        tokenString: token
      },
    });
  } catch (error) {
    adminApi.defaults.headers.common = null;
    dispatch({
      type: types.SIGN_IN_ERROR,
      payload: {
        user: null,
        message:
            error?.response?.data?.message || 'Usuario/Contraseńa incorrecta',
      },
    });
  }
};

export const onValidateToken = ({ token }) => (dispatch) => {
  if (token) {
    const user = jwtDecode(token);
    dispatch({
      type: types.SIGN_VALIDATE_TOKEN,
      payload: {
        user,
        tokenString: token
      },
    });
    adminApi.defaults.headers.common = { Authorization: `Bearer ${token}` };
  } else {
    dispatch({ type: types.SIGN_OUT });
    adminApi.defaults.headers.common = null;
  }
};

export const showLogin = () => (dispatch) => dispatch({ type: types.SHOW_LOGIN });

export const hideLogin = () => (dispatch) => dispatch({ type: types.HIDE_LOGIN });
